import type { JSONContent } from '@tiptap/core';

import { sanitizeHref } from '../_components/TiptapRenderer/serializer';

const EXCERPT_CAP = 300;

const collectText = (node: JSONContent | null | undefined, parts: string[]): void => {
  if (!node) return;
  if (typeof node.text === 'string') parts.push(node.text);
  if (node.type === 'mention' && typeof node.attrs?.label === 'string') parts.push(node.attrs.label);
  if (Array.isArray(node.content)) {
    for (const child of node.content) collectText(child, parts);
  }
};

/** Plain-text body for the 3-line preview. CSS clamps visually; the cap bounds DOM size. */
export const extractExcerpt = (tiptapState: JSONContent | null | undefined): string => {
  const parts: string[] = [];
  collectText(tiptapState, parts);
  const joined = parts.join(' ').replace(/\s+/g, ' ').trim();
  return [...joined].slice(0, EXCERPT_CAP).join('');
};

const findFirst = (node: JSONContent | null | undefined, type: string, attr: string): string | null => {
  if (!node) return null;
  if (node.type === type) {
    const value = node.attrs?.[attr];
    if (typeof value === 'string' && value.length > 0) return value;
  }
  if (Array.isArray(node.content)) {
    for (const child of node.content) {
      const found = findFirst(child, type, attr);
      if (found) return found;
    }
  }
  return null;
};

/** First inline image, else first link-preview image, else null (text runs full width). */
export const extractThumbnail = (tiptapState: JSONContent | null | undefined): string | null =>
  sanitizeHref(findFirst(tiptapState, 'image', 'src')) ?? sanitizeHref(findFirst(tiptapState, 'linkCard', 'image'));
